import { change } from 'redux-form';
import { get } from 'lodash';
import { updateListing } from '../../../app-main/actions/listing';
import { toggleBanner } from '../../../app-main/actions/banner';
import { updatePrice } from '../../../app-main/actions/listingPricing';
import { FANDB_FORM } from '../constants';

const onSubmitIsFnb = (value, dispatch, props) => {
  const priceId = get(props, 'listing.prices.0._id', '');
  const accessToken = get(props, 'accessToken', '');
  const listingId = get(props, 'listing._id', '');
  const isFandBRequires = 'true' === value;
  const fnbPayload = {
    currency: get(props, 'listing.prices.0.currency', 'USD'),
    display_gratuity_percent: 0,
    gratuity_percent: 0,
    tax_percent: 0,
    value: get(props, 'listing.prices.0.value', 0)
  };

  if (!isFandBRequires) {
    dispatch(updateListing(listingId, accessToken, { fandb_required: isFandBRequires, fandb_applies_to: '' }))
      .then(() => {
        const fandBPrices = get(props, 'fandBPrices', {});
        // Reset the values of fanb pricing when user select 'NO'
        dispatch(change(FANDB_FORM, 'prices', { ...fandBPrices, ...fnbPayload }));
        dispatch(updatePrice(priceId, accessToken, fnbPayload));
      })
      .then(() => dispatch(toggleBanner('save')))
      .catch(() => dispatch(toggleBanner('error')));
  }
};

export default onSubmitIsFnb;
